import { render } from "./Bill.vue?vue&type=template&id=61f13be0&scoped=true"
import script from "./Bill.vue?vue&type=script&lang=js"
export * from "./Bill.vue?vue&type=script&lang=js"

import "./Bill.vue?vue&type=style&index=0&id=61f13be0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61f13be0"]])

export default __exports__